import React, {Component} from 'react'
import {Configure, Index} from 'react-instantsearch-dom'
import CustomHits from './custom-hits'
import {ALGOLIA_COLLECTION_FILTER_RULES} from '../../config'

export default class DropDownResults extends Component {
  constructor(props, state) {
    super(props)

    this.state = {
      products: 0,
      collections: 0,
      articles: 0
    }

    this.updateResults = this.updateResults.bind(this)
  }

  updateResults(algoliaIndexType, numberOfResults) {
    this.setState({
      [algoliaIndexType]: numberOfResults,
    })
  }

  render() {
    const { index } = this.props
    const { products, articles, collections } = this.state
    const hasNoResults = products === 0 && articles === 0 && collections === 0
    return (
      <React.Fragment>
        <div className="row">
          {hasNoResults && (
            <p className="margin-bottom-1x">
              Your search did not return any results.
            </p>
          )}
          <Index indexName={index.products}>
            <Configure hitsPerPage={10} filters={ALGOLIA_COLLECTION_FILTER_RULES} />
            <CustomHits
              type={`products`}
              updateResults={this.updateResults}
              results={this.state}
            />
          </Index>
          <Index indexName={index.collections}>
            <Configure hitsPerPage={5} />
            <CustomHits
                type={`collections`}
                updateResults={this.updateResults}
                results={this.state}
            />
          </Index>
          <Index indexName={index.articles}>
            <Configure hitsPerPage={3} />
            <CustomHits
                type={`articles`}
                updateResults={this.updateResults}
                results={this.state}
            />
          </Index>

        </div>
      </React.Fragment>
    )
  }
}
